(() => {
  const productInfo = document.querySelector('product-info[data-section-type="product-page"]');
  if (!productInfo) return;

  // T5-C1 owner-approved final layout. Theme rendering only: no product,
  // variant, price, inventory or media records are changed here.
  const option = 'option-b';
  document.documentElement.dataset.iyrsT5cPdp = option;
  document.documentElement.dataset.iyrsPdpLayoutLock = 'true';
  productInfo.dataset.iyrsT5cPdp = option;

  const normalizeLength = (value) => {
    const match = String(value || '').trim().match(/^(\d+)\s*(?:in|inch|inches|")$/i);
    return match ? `${match[1]}"` : value;
  };

  productInfo.querySelectorAll('.m-product-option').forEach((group) => {
    const optionName = group.querySelector('[data-option-name]')?.dataset.optionName
      || group.querySelector('.option-label--title')?.textContent
      || '';
    if (!/length/i.test(optionName)) return;
    group.querySelectorAll('.m-product-option--node__label').forEach((label) => {
      const textNode = label.querySelector('.iyrs-option-swatch-label') || label.firstChild;
      if (textNode?.nodeType === Node.TEXT_NODE) textNode.textContent = normalizeLength(textNode.textContent);
      else if (textNode) textNode.textContent = normalizeLength(textNode.textContent);
    });
    const selected = group.querySelector('.option-label--selected');
    if (selected) selected.textContent = normalizeLength(selected.textContent);
  });

  const gallery = productInfo.querySelector('media-gallery');
  const mediaItems = [...(gallery?.querySelectorAll('.m-media-gallery__list > .m-product-media--item') || [])];
  const thumbnails = [...(gallery?.querySelectorAll('.m-product-media--slider__thumbnails .swiper-slide') || [])];
  if (!gallery || !mediaItems.length) return;

  const activate = (index) => {
    const normalizedIndex = Math.max(0, Math.min(Number(index) || 0, mediaItems.length - 1));
    mediaItems.forEach((item, itemIndex) => {
      item.classList.toggle('is-t5c-active', itemIndex === normalizedIndex);
      item.setAttribute('aria-hidden', String(itemIndex !== normalizedIndex));
    });
    thumbnails.forEach((thumbnail, itemIndex) => {
      thumbnail.classList.toggle('is-t5c-active', itemIndex === normalizedIndex);
      thumbnail.setAttribute('aria-selected', String(itemIndex === normalizedIndex));
      thumbnail.setAttribute('role', 'button');
      thumbnail.setAttribute('tabindex', '0');
    });

    const selectedThumbnail = thumbnails[normalizedIndex];
    const rail = selectedThumbnail?.closest('.nav-swiper-container');
    if (selectedThumbnail && rail && rail.scrollWidth > rail.clientWidth) {
      const targetLeft = selectedThumbnail.offsetLeft - ((rail.clientWidth - selectedThumbnail.offsetWidth) / 2);
      rail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }
  };

  thumbnails.forEach((thumbnail, index) => {
    const choose = () => activate(index);
    thumbnail.addEventListener('click', choose);
    thumbnail.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      choose();
    });
  });

  document.addEventListener('variant:changed', (event) => {
    const mediaId = event.detail?.variant?.featured_media?.id;
    if (!mediaId) return;
    const index = mediaItems.findIndex((item) => Number(item.dataset.mediaId) === Number(mediaId));
    if (index >= 0) activate(index);
  });

  activate(0);
})();
